import { render, staticRenderFns } from "./AppWorks.vue?vue&type=template&id=88f1b4aa&scoped=true&"
import script from "./AppWorks.vue?vue&type=script&lang=js&"
export * from "./AppWorks.vue?vue&type=script&lang=js&"
import style0 from "./AppWorks.vue?vue&type=style&index=0&id=88f1b4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f1b4aa",
  null
  
)

export default component.exports